export class TerminationForm {
    constructor() {
        this.formtoggle = document.querySelector('#incognitoForm');
        this.backtoggleBtn = document.querySelector('#backBtn');
        this.formtoggleBtn = document.querySelector('#incognitoBtn');
        this.intro = document.querySelector('#intro');
        this.form = document.querySelector('#form-termination');
        this.prodChoice = document.querySelector('#terminationProd');
        this.product = document.querySelector('#tf-product');

        this.art = document.querySelector('#terminationArt');
        this.reason1 = document.querySelector('#reason1');
        this.reason2 = document.querySelector('#reason2');
        this.print = document.querySelector('#pva-print');
        this.digital = document.querySelector('#pva-digital');

        this.init();
    };

    init() {
        this.form.addEventListener('submit', this.submit.bind(this));

        this.formtoggleBtn.addEventListener('click', event => {
            if(this.formtoggle.classList.contains('d-none')) {
                this.formtoggle.classList.remove('d-none');
                this.intro.classList.add('d-none');
            }
        });
        this.backtoggleBtn.addEventListener('click', event => {
            if(this.intro.classList.contains('d-none')) {
                this.formtoggle.classList.add('d-none');
                this.intro.classList.remove('d-none');
            } 
        });

        this.prodChoice.addEventListener('change', event => {
            this.product.value = this.prodChoice.value;
            if(this.product.value == 'digital') {
                this.print.classList.add('d-none');
                this.digital.classList.remove('d-none');
            } else {
                this.print.classList.remove('d-none');
                this.digital.classList.add('d-none');
            }
        });
        this.prodChoice.dispatchEvent(new CustomEvent('change'));

        this.art.addEventListener('change', event => {
            if(this.art.value == 'ordentliche Kündigung') {
                this.reason1.classList.add('d-none');
                this.reason2.classList.remove('d-none');
            } else {
                this.reason1.classList.remove('d-none');
                this.reason2.classList.add('d-none');
            }
        });
        this.art.dispatchEvent(new CustomEvent('change'));
    };

    submit(event) {
        event.preventDefault();
        let request = new Request('POST', this.form.getAttribute('action'));
        request.formData = this.form;

        request.call(function(data) {
            if(data.status == 'ok') {
                window.location.replace(data.redirect);
            } else {
                this.error(data.fields);
            }
        }.bind(this));
    };

    error(errors) {
        this.clearErros();
        errors.forEach(error => {
            let elements = document.querySelectorAll('.form-error-' + error.field);
            if(elements) {
                elements.forEach(element => {
                    if(error.message != '') {
                        element.querySelector('p').innerHTML = error.message;
                    }
                    element.classList.remove('d-none');
                });
            }
        });
    };

    clearErros() {
        let elements = document.querySelectorAll('.form-error');
        if(elements) {
            elements.forEach(element => {
                element.classList.add('d-none');
            });
        }
    }
}
